import {
  DesktopDatePicker,
  DesktopDatePickerProps,
} from "@mui/x-date-pickers/DesktopDatePicker";

export type { DesktopDatePickerProps };
export default DesktopDatePicker;
